import React, { useState } from 'react';
import { 
  Avatar, 
  Button, 
  Typography, 
  Card, 
  Space, 
  Row, 
  Col, 
  Rate,
  Tag,
  Divider,
  Modal,
  Input,
  List,
  message
} from 'antd';
import { 
  UserOutlined, 
  LeftOutlined,
  PhoneOutlined,
  MessageOutlined,
  StarOutlined,
  SwapOutlined,
  CommentOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
  CheckOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text, Paragraph } = Typography;
const { Search } = Input;

// 模拟二维码图片URL (实际项目中应替换为真实的企业微信二维码图片URL)
const qrCodeUrl = 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png';

// 模拟管家数据
const butlerData = {
  id: '1',
  name: '李丽娜',
  avatar: '',  // 实际应为头像URL
  rating: 4.8,
  isNew: false,
  phone: '138****6688',
  serviceYears: 3,
  introduction: '资深酒店管家，擅长酒店预订和专属服务定制，致力于为您提供超出期待的住宿体验。',
  totalServiceCount: 568,
  responseRate: '98%'
};

// 模拟推荐管家数据
const recommendedButlers = [
  {
    id: '101',
    name: '王梦然',
    workId: 'BT10023',
    avatar: '',
    rating: 4.9,
    isNew: false,
    introduction: '五星酒店从业10年经验，熟悉各类客户需求，为您提供专业贴心服务。'
  },
  {
    id: '102',
    name: '陈冠宇',
    workId: 'BT10045',
    avatar: '',
    rating: 4.7,
    isNew: false,
    introduction: '精通英日韩多国语言，擅长为国际客户提供定制化酒店服务。'
  },
  {
    id: '103',
    name: '张雨晴',
    workId: 'BT10089',
    avatar: '',
    rating: 4.5,
    isNew: false,
    introduction: '拥有丰富高端酒店资源，深谙奢华服务之道，致力打造尊贵体验。'
  },
  {
    id: '104',
    name: '林小雨',
    workId: 'BT10134',
    avatar: '',
    rating: 4.6,
    isNew: false,
    introduction: '擅长亲子家庭出行服务，深入了解家庭客户需求，提供便捷舒适体验。'
  },
  {
    id: '105',
    name: '赵敏',
    workId: 'BT10178',
    avatar: '',
    rating: 4.8,
    isNew: false,
    introduction: '专注商务客户服务，高效解决预订和入住中的各类问题。'
  },
  {
    id: '106',
    name: '吴思思',
    workId: 'BT10205',
    avatar: '',
    rating: 0,
    isNew: true,
    introduction: '新晋酒店管家，专业细致，热情周到，期待为您服务。'
  }
];

const MyButlerPage: React.FC = () => {
  const navigate = useNavigate();
  const [contactModalVisible, setContactModalVisible] = useState(false);
  const [changeButlerModalVisible, setChangeButlerModalVisible] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [selectedButlerId, setSelectedButlerId] = useState('');
  
  // 显示联系方式弹窗
  const showContactModal = () => {
    setContactModalVisible(true);
  };
  
  // 关闭联系方式弹窗
  const handleCancelContact = () => {
    setContactModalVisible(false);
  };
  
  // 打开更换管家弹窗
  const showChangeButlerModal = () => {
    setChangeButlerModalVisible(true);
  };
  
  // 关闭更换管家弹窗
  const handleCancelChangeButler = () => {
    setChangeButlerModalVisible(false);
    setSearchValue('');
    setSelectedButlerId('');
  };
  
  // 搜索管家
  const handleSearch = (value: string) => {
    setSearchValue(value);
  };
  
  // 选择管家
  const handleSelectButler = (butlerId: string) => {
    setSelectedButlerId(butlerId);
  };
  
  // 确认选择管家
  const handleConfirmSelection = () => {
    if (!selectedButlerId) {
      message.error('请选择一位管家');
      return;
    }
    
    // 这里可以添加确认更换管家的API调用
    const selectedButler = recommendedButlers.find(butler => butler.id === selectedButlerId);
    
    message.success(`您已成功选择${selectedButler?.name}为您的专属管家`);
    handleCancelChangeButler();
  };
  
  // 过滤管家列表
  const filteredButlers = recommendedButlers.filter(butler => {
    if (!searchValue) return true;
    
    const searchLowerCase = searchValue.toLowerCase();
    return (
      butler.name.toLowerCase().includes(searchLowerCase) ||
      butler.workId.toLowerCase().includes(searchLowerCase)
    );
  });
  
  // 打开服务评价弹窗
  const showServiceRatingModal = () => {
    Modal.info({
      title: '服务评价功能即将上线',
      content: '非常感谢您的支持，服务评价功能正在开发中，即将上线。',
      okText: '我知道了'
    });
  };
  
  // 打开问题反馈弹窗
  const showFeedbackModal = () => {
    Modal.info({
      title: '问题反馈',
      content: '如有任何问题或意见，请联系您的专属管家或拨打客服热线：400-123-4567',
      okText: '我知道了'
    });
  };
  
  return (
    <div style={{ 
      maxWidth: 500, 
      margin: '0 auto', 
      background: '#f5f5f5', 
      minHeight: '100vh'
    }}>
      {/* 顶部标题栏 */}
      <div style={{ 
        padding: '12px 16px', 
        background: '#fff', 
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #f0f0f0',
      }}>
        <Button 
          type="text" 
          icon={<LeftOutlined />} 
          onClick={() => navigate(-1)}
          style={{ marginRight: 16 }}
        />
        <div style={{ fontSize: 16, fontWeight: 'bold' }}>我的管家</div>
      </div>
      
      {/* 主内容区 */}
      <div style={{ padding: '16px' }}>
        {/* 管家信息卡片 */}
        <Card 
          style={{ 
            borderRadius: 8, 
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            marginBottom: 16 
          }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Avatar 
              size={80} 
              icon={<UserOutlined />} 
              src={butlerData.avatar} 
              style={{ backgroundColor: '#529C8A' }} 
            />
            <div style={{ marginLeft: 16, flex: 1 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <Title level={4} style={{ margin: 0 }}>{butlerData.name}</Title>
                <Button
                  type="primary"
                  shape="round"
                  icon={<PhoneOutlined />}
                  size="small"
                  onClick={showContactModal}
                  style={{ backgroundColor: '#529C8A', borderColor: '#529C8A' }}
                >
                  联系方式
                </Button>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
                {butlerData.isNew ? (
                  <Tag color="#529C8A">新晋管家</Tag>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Rate disabled defaultValue={butlerData.rating} style={{ fontSize: 14 }} />
                    <span style={{ marginLeft: 8, color: '#faad14', fontWeight: 'bold' }}>{butlerData.rating}</span>
                  </div>
                )}
              </div>
              
              <div style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>
                服务时长: {butlerData.serviceYears}年 | 服务客户: {butlerData.totalServiceCount}位
              </div>
              
              <Paragraph 
                ellipsis={{ rows: 2 }}
                style={{ fontSize: 14, margin: 0, color: '#333' }}
              >
                {butlerData.introduction}
              </Paragraph>
            </div>
          </div>
          
          <Divider style={{ margin: '16px 0' }} />
          
          <Row gutter={16}>
            <Col span={12}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: '#529C8A', fontWeight: 'bold', fontSize: 20 }}>{butlerData.totalServiceCount}</div>
                <div style={{ fontSize: 13, color: '#666' }}>服务客户</div>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: '#529C8A', fontWeight: 'bold', fontSize: 20 }}>{butlerData.rating}</div>
                <div style={{ fontSize: 13, color: '#666' }}>服务评分</div>
              </div>
            </Col>
          </Row>
        </Card>
        
        {/* 服务说明 */}
        <Card
          title="专属服务"
          style={{ 
            borderRadius: 8, 
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            marginBottom: 16 
          }}
        >
          <div style={{ color: '#666', fontSize: 14 }}>
            <p>• 一对一专属咨询，尊享个性化服务</p>
            <p>• 预订帮助与房型推荐</p>
            <p>• 专属优惠与福利</p>
            <p>• 入住期间全程协助</p>
            <p>• 问题快速解决与反馈</p>
          </div>
        </Card>
        
        {/* 操作区 */}
        <div style={{ padding: '24px 0' }}>
          <Row gutter={12}>
            <Col span={8}>
              <Button 
                type="primary" 
                block 
                size="large" 
                icon={<SwapOutlined />}
                onClick={showChangeButlerModal}
                style={{ backgroundColor: '#529C8A', borderColor: '#529C8A', height: 48 }}
              >
                更换管家
              </Button>
            </Col>
            <Col span={8}>
              <Button 
                block 
                size="large" 
                icon={<StarOutlined />}
                onClick={showServiceRatingModal}
                style={{ height: 48 }}
              >
                服务评价
              </Button>
            </Col>
            <Col span={8}>
              <Button 
                block 
                size="large" 
                icon={<CommentOutlined />}
                onClick={showFeedbackModal}
                style={{ height: 48 }}
              >
                问题反馈
              </Button>
            </Col>
          </Row>
        </div>
      </div>
      
      {/* 联系方式弹窗 */}
      <Modal
        title="联系方式"
        open={contactModalVisible}
        onCancel={handleCancelContact}
        footer={[
          <Button key="close" onClick={handleCancelContact}>
            关闭
          </Button>
        ]}
        centered
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: 24 }}>
            <div style={{ marginBottom: 8, fontWeight: 'bold' }}>专属管家手机号</div>
            <Button 
              type="primary" 
              icon={<PhoneOutlined />}
              size="large"
              style={{ backgroundColor: '#529C8A', borderColor: '#529C8A' }}
            >
              {butlerData.phone}
            </Button>
          </div>
          
          <Divider />
          
          <div>
            <div style={{ marginBottom: 16, fontWeight: 'bold' }}>企业微信二维码</div>
            <div style={{ marginBottom: 16 }}>
              <img 
                src={qrCodeUrl} 
                alt="企业微信二维码" 
                style={{ 
                  width: 180, 
                  height: 180, 
                  display: 'block', 
                  margin: '0 auto',
                  border: '4px solid #ffffff',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }} 
              />
            </div>
            <div style={{ color: '#666', fontSize: 14 }}>
              扫码添加，获取更多专属服务
            </div>
          </div>
        </div>
      </Modal>
      
      {/* 更换管家弹窗 */}
      <Modal
        title="选择推荐管家"
        open={changeButlerModalVisible}
        onCancel={handleCancelChangeButler}
        footer={[
          <Button key="cancel" onClick={handleCancelChangeButler}>
            取消
          </Button>,
          <Button 
            key="confirm" 
            type="primary" 
            onClick={handleConfirmSelection}
            disabled={!selectedButlerId}
            style={{ backgroundColor: '#529C8A', borderColor: '#529C8A' }}
          >
            确认选择
          </Button>
        ]}
        width={480}
      >
        <div>
          <Search
            placeholder="搜索管家姓名或工号"
            allowClear
            enterButton={<SearchOutlined />}
            size="middle"
            onSearch={handleSearch}
            style={{ marginBottom: 16 }}
          />
          
          <List
            itemLayout="horizontal"
            dataSource={filteredButlers}
            renderItem={butler => (
              <List.Item 
                style={{ 
                  padding: '12px 16px', 
                  borderRadius: 8, 
                  marginBottom: 8,
                  cursor: 'pointer',
                  background: selectedButlerId === butler.id ? 'rgba(82, 156, 138, 0.1)' : '#fff',
                  border: selectedButlerId === butler.id ? '1px solid #529C8A' : '1px solid #f0f0f0'
                }}
                onClick={() => handleSelectButler(butler.id)}
              >
                <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                  <Avatar 
                    size={50} 
                    icon={<UserOutlined />} 
                    src={butler.avatar}
                    style={{ backgroundColor: selectedButlerId === butler.id ? '#529C8A' : '#d9d9d9' }}
                  />
                  <div style={{ flex: 1, marginLeft: 12, marginRight: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                      <Text strong style={{ marginRight: 8 }}>{butler.name}</Text>
                      <Text type="secondary" style={{ fontSize: 12 }}>工号: {butler.workId}</Text>
                    </div>
                    <div style={{ marginBottom: 4 }}>
                      {butler.isNew ? (
                        <Tag color="#529C8A" style={{ fontSize: 12 }}>新晋管家</Tag>
                      ) : (
                        <Rate disabled defaultValue={butler.rating} style={{ fontSize: 12 }} />
                      )}
                    </div>
                    <Paragraph ellipsis style={{ fontSize: 12, color: '#666', margin: 0 }}>
                      {butler.introduction}
                    </Paragraph>
                  </div>
                  <div style={{ 
                    width: 24, 
                    height: 24, 
                    borderRadius: '50%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    border: selectedButlerId === butler.id ? 'none' : '1px solid #d9d9d9',
                    backgroundColor: selectedButlerId === butler.id ? '#529C8A' : 'transparent'
                  }}>
                    {selectedButlerId === butler.id && (
                      <CheckOutlined style={{ color: '#fff', fontSize: 14 }} />
                    )}
                  </div>
                </div>
              </List.Item>
            )}
          />
        </div>
      </Modal>
    </div>
  );
};

export default MyButlerPage; 